var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnblockedSign = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19 19v2H5v-2h14Zm1-1v-8a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1v2l-.154-.004a3 3 0 0 1-2.842-2.842L2 18v-8a3 3 0 0 1 2.846-2.996L5 7h14l.154.004A3 3 0 0 1 22 10v8l-.004.154a3 3 0 0 1-2.842 2.842L19 21v-2a1 1 0 0 0 1-1Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.346 2.567a1 1 0 0 1 1.308 0l5.113 4.427c.656.568.32 1.615-.488 1.743l-.167.013H6.888l-.167-.013c-.808-.128-1.144-1.175-.488-1.743l5.113-4.427ZM8.229 7.25h7.543L12 3.984 8.229 7.25ZM14.395 10.557a.75.75 0 0 1 1.289.752l-.036.069-3.5 6a.75.75 0 0 1-1.234.09l-2-2.5-.045-.062a.75.75 0 0 1 1.166-.932l.05.057 1.317 1.647 2.95-5.056.043-.065Z"
})));
SvgUnblockedSign.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnblockedSign);
export default ForwardRef;